module.exports = __webpack_public_path__ + "img/br39.a9c01af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br39.jpg
// module id = Nc/f
// module chunks = 0